<template>
  <div id="box">
    <ScaleScreen :width="1920" :height="1080" class="scale-wrap">
      <div class="bg">
        <!-- 大屏显示 - 头标题 -->
        <div class="top_title_box">
          <!-- 标题高光 -->
          <div class="high_light_box">
            <div class="d-flex jc-center">
              <div class="title">
                <span class="title-text">船舶智能监控ㆍ数字驾驶舱</span>
              </div>
            </div>
            <!-- 显示时间 -->
            <div class="timers">
              {{ dateYear }} {{ dateWeek }} {{ dateDay }}
            </div>

            <!-- 时间选择器 -->
            <div class="hright">
              <div id="fullScreenBtn" style="margin-right: 20px; cursor: pointer" @click="toggleFull()">
                全屏显示
              </div>
              <el-date-picker :popper-append-to-body="false" class="custom-timeselect" v-model="time"
                popper-class="mydatestyle" @change="againRequest()" type="daterange" range-separator="至" size="mini"
                value-format="yyyy-MM-dd" style="width: 70%"></el-date-picker>
            </div>
          </div>
        </div>
        <div class="big_view_content">
          <!-- 左边 -->
          <div class="content_left_box">
            <div class="top_box">
              <!-- 标题 -->
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 150px; height: 30px">
                  <p>告警总数</p>
                </dv-decoration-7>
              </div>

              <!-- 内容 -->
              <div class="content_box">
                <div class="box1">
                  <div class="bg">
                    <div class="count">
                      <countTo :startVal="totalAlarmCount.old" :endVal="totalAlarmCount.new" :duration="3000"
                        style="color: rgb(244, 6, 69)"></countTo>
                    </div>
                  </div>
                  <div class="title" style="color: rgb(244, 6, 69)">
                    告警总数
                  </div>
                </div>
                <div class="box2">
                  <div class="bg">
                    <div class="count">
                      <countTo :startVal="totalUntreatedAlarmCount.old" :endVal="totalUntreatedAlarmCount.new"
                        :duration="3000" style="color: rgb(246, 162, 23)"></countTo>
                    </div>
                  </div>
                  <div class="title" style="color: rgb(246, 162, 23)">
                    未处理告警
                  </div>
                </div>
                <div class="box3">
                  <div class="bg">
                    <div class="count">
                      <countTo :startVal="totalProcessedAlarmCount.old" :endVal="totalProcessedAlarmCount.new"
                        :duration="3000" style="color: rgb(0, 220, 225)"></countTo>
                    </div>
                  </div>
                  <div class="title" style="color: rgb(0, 220, 225)">
                    已处理告警
                  </div>
                </div>
              </div>
            </div>
            <!-- 左 中 直播-->
            <div class="middle_left">
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 150px; height: 20px">
                  <p>船载视频</p>
                </dv-decoration-7>
              </div>
              <div class="app-container">
                <div class="page">
                  <div class="page_left">
                    <div v-if="isPaly">
                      <div class="filter-input-container">
                        <el-input prefix-icon="el-icon-search" size="mini" placeholder="输入关键字进行查询" v-model="filterText"
                          @change="changeText"></el-input>
                      </div>
                      <div class="tree-title">
                        <img src="@/assets/images/list.png" width="12px" height="12px"
                          style="margin-left: 10px; margin-right: 5px" />
                        <span>设备列表</span>
                      </div>
                      <el-tree highlight-current check-on-click-node node-key="value" :key="cascaderKey"
                        class="filter-tree" :data="companyList" :props="{ lable: 'name' }"
                        :filter-node-method="filterNode" @node-click="handleNodeClick" ref="tree">
                        <span class="custom-tree-node" slot-scope="{ node, data }"
                          style="position: relative; width: 100%">
                          <div v-if="data.icon === 'aiMonitor'" style="display: flex; align-items: center">
                            <img src="/statics/playOne.svg" style="
                                width: 24px;
                                margin-right: 5px;
                                margin-top: 4px;
                              " title="播放" />
                            <span>{{ data.label }}</span>

                            <span :id="`camer_${data.value}`">
                              <img src="/statics/nvr_online.svg" style="
                                  position: absolute;
                                  right: 15px;
                                  width: 15px;
                                  top: 3px;
                                " title="摄像头在线" />
                            </span>
                          </div>

                          <span v-else-if="data.icon === 'playImg'">
                            {{ data.label }}

                            <img src="/statics/playAll.svg" style="
                                position: absolute;
                                right: 10px;
                                width: 25px;
                              " title="播放全部"  @click.stop="playAll(data)"/>
                            <span :id="`nvr_${data.boxCode}`">
                              <img src="/statics/nvr_online.svg" style="
                                  position: absolute;
                                  right: 45px;
                                  width: 15px;
                                " title="nvr在线" />
                            </span>
                            <span :id="`box_${data.value}`">
                              <img src="/statics/box_online.svg" style="
                                  position: absolute;
                                  right: 78px;
                                  width: 15px;
                                  top: -1px;
                                " title="Ai智能终端在线" />
                            </span>
                          </span>

                          <span v-else>
                            {{ data.label }}
                          </span>
                        </span>
                      </el-tree>
                    </div>

                    <!-- 回放 -->
                    <div class="record-list-box-box" v-else>
                      <!--          顶部选择-->
                      <div class="filter-input">
                        <el-input v-if="!selectPlayPick" prefix-icon="el-icon-search" size="mini"
                          placeholder="输入关键字进行过滤" v-model="filterText" @change="changeText"></el-input>
                      </div>

                      <!--          树选择-->
                      <div>
                        <div v-if="selectPlayPick" class="record-list-box">
                          <div style="
                              margin-left: 10px;
                              margin-top: -12px;
                              margin-bottom: 10px;
                            ">
                            <i class="el-icon-back" style="cursor: pointer" @click="back()"></i>
                            <span style="margin-left: 36px; font-size: 14px">
                              选择回放日期
                            </span>
                            <!-- <div>
                              <el-date-picker
                                size="mini"
                                style="width: 250px; margin-top: 10px"
                                v-model="chooseDate"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="日期"
                                @change="dateChange()"
                              ></el-date-picker>
                            </div> -->
                          </div>
                          <div>
                            <span style="font-size: 14px">开始日期</span>
                          </div>
                          <div style="
                              margin-top: 5px;
                              display: flex;
                              align-items: center;
                            ">
                            <el-date-picker size="mini" v-model="startTime" type="datetime" class="input"
                              placeholder="日期"></el-date-picker>
                          </div>
                          <div style="margin-top: 5px">
                            <span style="font-size: 14px">结束日期</span>
                          </div>
                          <div style="
                              margin-top: 5px;
                              display: flex;
                              align-items: center;
                            ">
                            <el-date-picker size="mini" v-model="endTime" type="datetime" class="input"
                              placeholder="日期"></el-date-picker>
                          </div>
                          <div style="margin-top: 5px">
                            <span style="font-size: 14px">
                              摄像头：{{ monitorDetail }}
                            </span>
                            <div style="width: 100%; margin-top: 10px" class="select">
                              <el-select v-model="monitorValue" placeholder="请选择">
                                <el-option v-for="(item, index) in monitorOptions" :key="index" :label="item.label"
                                  :value="item.value" @click.native="changeSnIdSelect(item)"></el-option>
                              </el-select>
                            </div>
                          </div>
                          <div style="
                              width: 143px;
                              height: 34px;
                              margin: 10px auto;
                            ">
                            <el-button type="primary" plain @click="toPlay" style="
                                width: 100%;
                                height: 100%;
                                background-color: #051427;
                                border-image: linear-gradient(
                                    to right,
                                    #011e75,
                                    #23b7cb
                                  )
                                  5 5;
                                color: white;
                              ">
                              开始回放
                            </el-button>
                          </div>
                          <!-- <ul v-if="detailFiles.length != 0">
                            <li style="margin-left: 10px; margin-top: -3px">
                              {{ companyName }}
                            </li>
                            <ul>
                              <li style="margin-left: 20px; margin-top: 5px">
                                {{ shipName }}
                              </li>
                              <ul>
                                <li
                                  style="
                                    margin-left: 30px;
                                    margin-top: 5px;
                                    margin-bottom: 5px;
                                  "
                                >
                                  {{ position }}
                                </li>
                                <ul
                                  v-if="detailFiles.length > 0"
                                  class="infinite-list record-list"
                                  style="background-color: #051427"
                                >
                                  <li
                                    v-for="item in detailFiles"
                                    class="infinite-list-item record-list-item"
                                  >
                                    <el-tag
                                      v-if="chooseFile != item"
                                      @click="checkedFile(item)"
                                    >
                                      <i class="el-icon-video-camera"></i>
                                      {{ formatStartTime(item.startTime) }}-{{
                                        formatEndTime(item.endTime)
                                      }}
                                    </el-tag>
                                    <el-tag
                                      v-if="chooseFile == item"
                                      type="danger"
                                    >
                                      <i class="el-icon-video-camera"></i>
                                      {{ formatStartTime(item.startTime) }}-{{
                                        formatEndTime(item.endTime)
                                      }}
                                    </el-tag>
                                  </li>
                                </ul>
                              </ul>
                            </ul>
                          </ul> -->
                        </div>

                        <el-tree v-else class="record-list-box" node-key="value" :data="companyList"
                          :default-expanded-keys="defaultExpandIds" :filter-node-method="filterNode"
                          :props="{ lable: 'name' }" @node-click="playBackClick" ref="tree"></el-tree>
                      </div>
                      <!-- <div
                        size="mini"
                        v-if="selectPlayPick && detailFiles.length == 0"
                        class="record-list-no-val"
                      >
                        暂无数据
                      </div>
                      <div
                        size="mini"
                        v-if="selectPlayPick && companyList.length == 0"
                        class="record-list-no-val"
                      >
                        暂无数据
                      </div> -->
                    </div>
                    <!-- <Playback
                      :isToken="token"
                      :mediaServiceToken="mediaServiceToken"
                      ref="playback"
                    ></Playback> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 左 底部 -->
            <div class="middle_box">
              <!-- 标题 -->
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 150px; height: 30px">
                  <p>实时告警</p>
                </dv-decoration-7>
              </div>
              <div class="content_box">
                <vue-seamless-scroll :data="currentDataList" :class-option="defaultOption">
                  <ul>
                    <li v-for="(item, index) in currentDataList" :key="index">
                      <div class="alarm_item_info_box" @click="goDetail(item)">
                        <div class="info_right">
                          <div class="image_content">
                            <img :src="dealPicUrl(item.imageUrl)" style="width: 100%; height: 100%" />
                          </div>
                        </div>

                        <div class="info_middle">
                          <div class="info_content">
                            <div class="alarm_title">{{ item.title }}</div>
                            <div class="alarm_position">
                              {{ item.position }}
                            </div>
                            <div class="alarm_time">{{ item.time }}</div>
                          </div>
                        </div>
                        <div class="info_left">
                          <div class="one_box" style="position: relative">
                            <div style="
                                width: 63px;
                                height: 30px;
                                margin-right: 10%;
                              ">
                              <div v-if="
                                item.handleOver != null &&
                                item.handleOver != ''
                              " style="
                                  border: 1px solid rgb(65, 131, 218);
                                  text-align: center;
                                  color: rgb(150, 192, 231);
                                  font-size: 13px;
                                ">
                                处理超时
                              </div>
                            </div>
                            <div style="width: 65px; height: 30px">
                              <div v-if="
                                item.checkOver != null && item.checkOver != ''
                              " style="
                                  border: 1px solid rgb(64, 128, 211);
                                  text-align: center;
                                  color: rgb(147, 191, 231);
                                  font-size: 13px;
                                ">
                                确警超时
                              </div>
                            </div>
                          </div>
                          <div class="two_box">
                            <div style="
                                width: 63px;
                                height: 30px;
                                margin-right: 10%;
                              ">
                              <div style="
                                  border: 1px solid rgb(212, 212, 45);
                                  text-align: center;
                                  color: rgb(212, 212, 45);
                                  font-size: 13px;
                                ">
                                {{ item.level }}级别
                              </div>
                            </div>
                            <div style="width: 65px; height: 30px">
                              <div style="
                                  border: 1px solid rgb(3, 83, 188);
                                  text-align: center;
                                  color: rgb(167, 191, 223);
                                  background: rgb(3, 83, 188);
                                  font-size: 13px;
                                ">
                                待处理
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
          <!-- 中间 -->
          <!-- 视频/地图 -->
          <div class="content_middle_box" style="width: 40vw">
            <div class="one_box">
              <!-- 地图 -->
              <MapComponent v-if="show" ref="isMap" />
              <!-- 直播 -->
              <!-- <sup-video-player
                v-if="!show && isPaly"
                class="page_right"
                :split="1"
                ref="supPlayer"
              >
              </sup-video-player> -->
              <div class="one_box_live" v-show="!show && isPaly" ref="livelive">
                <live ref="live" :cameraIndexCode="cameraIndexCode" :hikvisionType="hikvisionType"></live>
              </div>
              <div v-if="!show && isPaly" class="videoBtn">
                <el-button type="primary" @click="isPlayBlack">
                  视频回放
                </el-button>
                <el-button @click="playNone" type="warning">
                  返回地图
                </el-button>
              </div>

              <div class="playBox" v-if="!show && !isPaly">
                <div style="width: 100%; height: 100%">
                  <play ref="black" :hikvisionType="hikvisionType"></play>
                </div>

                <!--<div style="height: 570px">
                  <player
                    ref="recordVideoPlayer"
                    :videoUrl="videoUrl"
                    :error="videoError"
                    :message="videoError"
                    :hasAudio="hasAudio"
                    style="max-height: 100%"
                    fluent
                    autoplay
                    live
                  ></player>
                </div>-->
                <div>
                  <div class="playRight" style="
                      margin-top: 3px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    ">
                    <!-- <el-button-group style="margin-top: 3px">
                      <el-button size="mini" title="播放" @click="gbPlay()">
                        <img
                          class="player-tools"
                          src="@/assets/images/start.png"
                        />
                      </el-button>
                      <el-button
                        size="mini"
                        class="iconfont icon-kaishi"
                        title="暂停"
                        @click="gbPause()"
                        style="margin-right: 10px; margin-left: 10px"
                      >
                        <img
                          class="player-tools"
                          src="@/assets/images/stop.png"
                        />
                      </el-button>
                      <el-dropdown
                        size="mini"
                        title="播放倍速"
                        @command="gbScale"
                      >
                        <el-button size="mini" style="height: 24px">
                          倍速
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="0.25"
                            >0.25倍速</el-dropdown-item
                          >
                          <el-dropdown-item command="0.5"
                            >0.5倍速</el-dropdown-item
                          >
                          <el-dropdown-item command="1.0"
                            >1倍速</el-dropdown-item
                          >
                          <el-dropdown-item command="2.0"
                            >2倍速</el-dropdown-item
                          >
                          <el-dropdown-item command="4.0"
                            >4倍速</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-button-group> -->
                    <el-button type="warning" style="margin-left: 20px" @click="(show = true) && (isPaly = true)">
                      返回地图
                    </el-button>
                  </div>
                  <!-- <el-slider
                    class="playtime-slider"
                    v-model="playTime"
                    id="playtimeSlider"
                    :disabled="detailFiles.length === 0"
                    :min="sliderMIn"
                    :max="sliderMax"
                    :range="true"
                    :format-tooltip="playTimeFormat"
                    @change="playTimeChange"
                    :marks="playTimeSliderMarks"
                  >
                  </el-slider>
                  <div class="slider-val-box">
                    <div
                      class="slider-val"
                      v-for="item of detailFiles"
                      :style="
                        'width:' +
                        getDataWidth(item) +
                        '%; left:' +
                        getDataLeft(item) +
                        '%'
                      "
                    ></div>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="tableBox">
              <div class="title_box" style="margin-left: 300px">
                <dv-decoration-7 class="title_content" style="width: 180px; height: 30px; padding-top: 15px">
                  <p style="color: #1dc1f5; padding: 15px; font-size: 18px">
                    船舶动态
                  </p>
                </dv-decoration-7>
              </div>
              <el-table :data="navigateStateList" max-height="195">
                <el-table-column width="80" label="序号" align="center" type="index" />

                <el-table-column label="船舶名称" align="center" prop="shipName">
                  <template slot-scope="scope">
                    <span :style="{ color: '#cf8c3a' }">
                      {{ scope.row.shipName }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column width="180" label="水道" align="center" prop="content">
                  <template slot-scope="scope">
                    <span :style="{ color: '#edf37c' }">
                      {{ scope.row.content }}
                    </span>
                  </template>
                </el-table-column>

                <el-table-column width="80" label="船舶状态" align="center" prop="state">
                  <template slot-scope="scope">
                    <span :style="{ color: getColorByState(scope.row.state) }" style="margin-left: 10px">
                      {{ scope.row.state }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column width="250" label="天气" align="center" prop="weather" />

                <el-table-column width="180" label="AIS更新" align="center" prop="time" />
              </el-table>
              <pagination v-show="total > 0" :pageSizes="[3]" :total="total" :page.sync="queryParams.pageNum"
                :limit.sync="queryParams.pageSize" @pagination="shipNavigateStateList" />
            </div>
          </div>
          <!-- 右边 -->
          <div class="content_right_box">
            <div class="top_box" style="padding: 10px">
              <!-- 标题 -->
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 180px; height: 30px">
                  <p>船舶状态</p>
                </dv-decoration-7>
              </div>
              <div style="display: flex; justify-content: space-around">
                <div class="stateBox">
                  <div ref="shorePowerOne" style="width: 90px; height: 100px; margin-left: -10px"></div>
                  <div style="
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      margin-top: -10px;
                      color: #4fec7b;
                    ">
                    <div style="font-weight: 800">
                      <span style="font-size: 24px">
                        {{ navigate.number || 0 }}
                      </span>
                      艘
                    </div>
                    <div style="font-weight: 800">航行船舶</div>
                  </div>
                </div>
                <div class="stateBox">
                  <div ref="shorePowerTwo" style="width: 90px; height: 100px; margin-left: -10px"></div>
                  <div style="
                      display: flex;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                      margin-top: -10px;
                      color: #00ffff;
                    ">
                    <div style="font-weight: 800">
                      <span style="font-size: 24px">
                        {{ mooring.number || 0 }}
                      </span>
                      艘
                    </div>
                    <div style="font-weight: 800">锚泊船舶</div>
                  </div>
                </div>
                <div class="stateBox">
                  <div ref="shorePowerThree" style="width: 90px; height: 100px; margin-left: -10px"></div>
                  <div style="
                      display: flex;
                      flex-direction: column;
                      align-items: center;
                      justify-content: center;
                      margin-top: -10px;
                      color: #edf37c;
                    ">
                    <div style="font-weight: 800">
                      <span style="font-size: 24px">
                        {{ anchor.number || 0 }}
                      </span>
                      艘
                    </div>
                    <div style="font-weight: 800">靠泊船舶</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="middle_box">
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 180px; height: 30px">
                  <p>安全信息服务</p>
                </dv-decoration-7>
              </div>
              <div class="btnTitle">
                <button v-for="(item, index) in btnList" :key="index" @click="showWaitList(index)" class="btnStyle"
                  :class="{ btnActive: activeTab === index }">
                  {{ item }}
                </button>
              </div>
              <div v-show="activeTab == 0">
                <notice-To-Mariner ref="noticetoMariner" :isToken="token"></notice-To-Mariner>
              </div>
              <div v-show="activeTab == 1">
                <navigation-Notice ref="navigationNotice" :isToken="token"></navigation-Notice>
              </div>
              <div v-show="activeTab == 2">
                <LevelAnnouncement :isToken="token" ref="levelAnnouncement"></LevelAnnouncement>
              </div>
              <div v-show="activeTab == 3">
                <WaterwayDimension :isToken="token" ref="waterwayDimension"></WaterwayDimension>
              </div>
              <div v-show="activeTab == 4">
                <WeatherForecastList :isToken="token" ref="weatherForecastList"></WeatherForecastList>
              </div>
              <div v-show="activeTab == 5">
                <Announcement :isToken="token" ref="announcement"></Announcement>
              </div>
            </div>
            <!-- 右  下 -->
            <div class="bottom_box">
              <div class="title_box">
                <dv-decoration-7 class="title_content" style="width: 150px; height: 30px">
                  <p>告警类型</p>
                </dv-decoration-7>
              </div>
              <div style="height: 100%; widows: 100%">
                <div id="pieChartContainer"></div>
              </div>
              <!-- <div class="emptyDiv">
                <dv-decoration-7 class="title_content" style="width:150px;height:30px;">
                  <p>饼状图</p>
                </dv-decoration-7>
                暂无数据
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </ScaleScreen>

    <!-- 告警详情弹框 -->
    <el-dialog :visible.sync="detailDialog">
      <div class="page_box">
        <el-descriptions class="page_top" ref="form" :model="form">
          <el-descriptions-item label="告警编码" prop="alarmId">
            {{ form.alarmId }}
          </el-descriptions-item>
          <el-descriptions-item label="船舶MMSI" prop="shipId">
            {{ form.shipMmsi }}
          </el-descriptions-item>
          <el-descriptions-item label="船舶名称" prop="shipNameCn">
            {{ form.shipNameCn }}
          </el-descriptions-item>
          <el-descriptions-item label="告警标题" prop="alarmTitle">
            {{ form.alarmTitle }}
          </el-descriptions-item>
          <el-descriptions-item label="告警等级" prop="alarmRank">
            <span style="color: red">{{ form.alarmRank }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="告警内容">
            {{ form.alarmContent }}
          </el-descriptions-item>
          <el-descriptions-item label="告警时间" prop="alarmTime">
            {{ form.alarmTime }}
          </el-descriptions-item>
          <el-descriptions-item label="告警地点" prop="alarmPlace">
            {{ form.alarmPlace }}
          </el-descriptions-item>
          <el-descriptions-item label="盒子ID" prop="boxId">
            {{ form.boxId }}
          </el-descriptions-item>
          <el-descriptions-item label="处置状态" prop="boxId">
            <span style="color: #9b1f00">
              {{ form.alarmHandleState === "1" ? "已处置" : "未处置" }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="处置结果" prop="boxId" v-if="!flag2">
            {{ form.alarmHandleRes }}
          </el-descriptions-item>
          <el-descriptions-item label="处置人员" prop="nickName" v-if="!flag2">
            {{ form.nickName }}
          </el-descriptions-item>
          <el-descriptions-item label="处置时间" prop="boxId" v-if="!flag2">
            {{ form.alarmHandleTime }}
          </el-descriptions-item>

          <el-descriptions-item label="备注" prop="remark">
            {{ form.remark }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="top1" v-if="flag2">
          <el-button type="warning" @click="openHandle">进行处置</el-button>
        </div>
        <div v-if="flag" style="border: 1px solid #0151fd; background-color: #ffffff">
          <div style="padding: 20px">
            <span style="color: #1e1e1e; text-align: left">
              告警编码:{{ this.form.alarmId }}
            </span>
          </div>
          <h2 style="text-align: center">
            针对船舶:{{ this.form.shipNameCn }}
            <span style="color: red">
              告警行为：{{ this.form.alarmContent }}
            </span>
          </h2>
          <h2 style="text-align: center">进行如下处置</h2>
          <div style="padding: 20px">
            <el-form ref="corm" :model="corm" :rules="crules" label-width="120px">
              <el-form-item label="告警处置结果" prop="alarmHandleRes">
                <el-select v-model="corm.alarmHandleRes" placeholder="请输入告警处置结果" class="alarmRes" prop="alarmHandleRes">
                  <el-option label="已通知立即纠正" value="已通知立即纠正"></el-option>
                  <el-option label="已核实情况" value="已核实情况"></el-option>
                  <el-option label="不适用" value="不适用"></el-option>
                  <el-option label="误报" value="误报"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input v-model="corm.remark" type="textarea" :rows="3" placeholder="请输入备注" />
              </el-form-item>
            </el-form>
          </div>
          <div class="top2">
            <el-button type="primary" @click="cSubit()">提交</el-button>
            <el-button @click="openHandle">取 消</el-button>
          </div>
        </div>

        <div class="page_bottom">
          <div class="page_bottom_left">
            <img :src="dealPicUrl(form.alarmPictureUrl)" width="100%" height="100%" />
          </div>
          <div class="page_bottom_right">
            <video :src="dealPicUrl(form.alarmVideoUrl)" width="100%" height="100%" controls></video>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { formatTime } from "@/utils/big_view_utils";
import moment from "moment";
import countTo from "vue-count-to";
import * as echarts from "echarts";
import { graphic } from "echarts";
import axios from "axios";
import vueSeamlessScroll from "vue-seamless-scroll";
import ScaleScreen from "@/components/scale-screen.vue";
import SupVideoPlayer from "@/components/SupVideoPlayer.vue";
import MapComponent from "@/views/map";
import { isFull, toggleFull } from "be-full";
import Playback from "@/components/playback.vue";
import player from "@/components/Jessibuca.vue";
import NoticeToMariner from "@/components/noticeToMariner.vue";
import NavigationNotice from "@/components/navigationNotice.vue";
import LevelAnnouncement from "@/components/levelAnnouncement.vue";
import WaterwayDimension from "@/components/waterwayDimension.vue";
import WeatherForecastList from "@/components/weatherForecastList.vue";
import Announcement from "@/components/announcement.vue";
import live from "@/components/haikang/live.vue";
import play from "@/components/haikang/playBlack.vue";
// import {getMonierStatus}from '@/api/work/ship_info'
export default {
  components: {
    play,
    live,
    countTo,
    vueSeamlessScroll,
    ScaleScreen,
    MapComponent,
    Playback,
    SupVideoPlayer,
    NoticeToMariner,
    player,
    NavigationNotice,
    LevelAnnouncement,
    WaterwayDimension,
    WeatherForecastList,
    Announcement,
  },
  data() {
    return {
      hikvisionType:'',
      monitorOptions: [],
      monitorValue: "",
      monitorDetail: "",
      monitorCode: "",
      arryList: [],
      cameraIndexCode: "",
      token: "Bearer ",
      mediaServiceToken: "",
      // 回放数据
      isPaly: true,
      selectPlayPick: false,
      channelId: null,
      deviceId: null,
      companyName: "",
      shipName: "",
      position: "",
      streamId: "",
      hasAudio: false,
      detailFiles: [],
      chooseDate: null,
      videoUrl: null,
      chooseFile: null,
      streamInfo: null,
      app: null,
      mediaServerId: null,
      ssrc: null,
      backUserInfo: [],
      sliderMIn: 0,
      sliderMax: 86400,
      autoPlay: true,
      taskUpdate: null,
      tabVal: "running",
      playTime: null,
      timeRange: null,
      startTime: null,
      endTime: null,
      playTimeSliderMarks: {
        0: "00:00",
        3600: "01:00",
        7200: "02:00",
        10800: "03:00",
        14400: "04:00",
        18000: "05:00",
        21600: "06:00",
        25200: "07:00",
        28800: "08:00",
        32400: "09:00",
        36000: "10:00",
        39600: "11:00",
        43200: "12:00",
        46800: "13:00",
        50400: "14:00",
        54000: "15:00",
        57600: "16:00",
        61200: "17:00",
        64800: "18:00",
        68400: "19:00",
        72000: "20:00",
        75600: "21:00",
        79200: "22:00",
        82800: "23:00",
        86400: "24:00",
      },
      //
      userId: null,
      // 总告警数
      totalAlarmCount: {
        old: 0,
        new: 0,
      },
      // 未处理告警数
      totalUntreatedAlarmCount: {
        old: 0,
        new: 0,
      },
      // 已处理告警数
      totalProcessedAlarmCount: {
        old: 0,
        new: 0,
      },
      // 今日告警数
      todayTotalAlarmCount: {
        old: 0,
        new: 0,
      },
      todayProcessedAlarmCount: {
        old: 0,
        new: 0,
      },
      todayUntreatedAlarmCount: {
        old: 0,
        new: 0,
      },
      // 航行船舶
      navigate: {
        type: "N",
        number: 0, //数量
        rate: "", //百分
      },
      // 锚泊船舶
      mooring: {
        type: "N",
        number: 0, //数量
        rate: "", //百分
      },
      // 靠泊船舶
      anchor: {
        type: "N",
        number: 0, //数量
        rate: "", //百分
      },
      // 船数
      totalShipCount: null,
      // 查询的时间范围
      queryTime: {
        startTime: null,
        endTime: null,
      },
      time: null,
      // 告警类型和个数
      alarmTypeAndCount: {
        alarmTypeData: null,
        alarmCountData: null,
      },
      // 时间范围内的已处理告警
      processedAlarmDate: {
        time: null,
        count: null,
      },
      untreatedAlarmDate: {
        time: null,
        count: null,
      },
      timing: null,
      showZero: false,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      // 实时告警数据
      currentDataList: [],
      // 请求地址前缀
      // BASE_URL: "http://cctv.hbrytech.cn:2123/prod-api/",
      // BASE_URL: "http://192.168.31.38:2023",
      MEDIA_URL: "https://gbs.hbrytech.cn:18080",
      initDataTimer: null,
      dailyDataList: {
        processedData: [],
        untreatedData: [],
      },
      cascaderKey: 1,
      defaultExpandIds: [], // 这里存放要默认展开的节点 id
      companyList: [],
      filterText: "",
      userInfo: {},
      mqtt_url: "",
      mqtt_options: {},
      aiBoxList: [],
      nvrList: [],
      cameraList: [],
      showBox: [],
      show: true,
      audio: new Audio(),
      successUrl: require("../../src/assets/tixing.mp3"),
      url: process.env.VUE_APP_BASE_WS + "/websocket/message",
      message: "",
      text_content: "",
      ws: null,
      type: 1,
      timer: null,
      resultList: [],
      oneList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      isShow: false,
      detailDialog: false, //详情弹框

      flag2: true,
      flag: false,
      form: [],
      corm: {},
      // 列表按钮
      btnList: [
        "航行通告",
        "航道通告",
        "水位公告",
        "航道尺度",
        "气象预报",
        "政务通告",
      ],
      activeTab: 0,
      loading: true,
      crules: {
        alarmHandleRes: [
          { required: true, message: "处置结果不能为空", trigger: "blur" },
        ],
      },
      boxList: [
        {
          id: "flv1",
          model: "",
          url: "#flv1",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv2",
          model: "",
          url: "#flv2",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv3",
          model: "",
          url: "#flv3",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv4",
          model: "",
          url: "#flv4",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv5",
          model: "",
          url: "#flv5",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv6",
          model: "",
          url: "#flv6",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv7",
          model: "",
          url: "#flv7",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv8",
          model: "",
          url: "#flv8",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv9",
          model: "",
          url: "#flv9",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv10",
          model: "",
          url: "#flv10",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv11",
          model: "",
          url: "#flv11",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv12",
          model: "",
          url: "#flv12",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv13",
          model: "",
          url: "#flv13",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv14",
          model: "",
          url: "#flv14",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv15",
          model: "",
          url: "#flv15",
          moniter: "",
          src: "",
          isReload: false,
        },
        {
          id: "flv16",
          model: "",
          url: "#flv16",
          moniter: "",
          src: "",
          isReload: false,
        },
      ],
      flv1: null,
      flv2: null,
      flv3: null,
      flv4: null,
      flv5: null,
      flv6: null,
      flv7: null,
      flv8: null,
      flv9: null,
      flv10: null,
      flv11: null,
      flv12: null,
      flv13: null,
      flv14: null,
      flv15: null,
      flv16: null,

      shorePowerChart: null,
      shorePowerChartTwo: null,
      shorePowerChartThree: null,
      navigateStateList: [],
      stopAll: false,//停止所有
    };
  },
  created() {
    let reg = new RegExp("(^|&)" + "data" + "=([^&]*)(&|$)", "i");
    let regTwo = new RegExp(
      "(^|&)" + "mediaServiceToken" + "=([^&]*)(&|$)",
      "i"
    );
    let r = window.location.search.substr(1).match(reg);
    let rMedia = window.location.search.substr(2).match(regTwo);
    this.token += decodeURIComponent(r[2]);
    this.mediaServiceToken += decodeURIComponent(rMedia[2]);
    localStorage.setItem("token", this.token);
    localStorage.setItem("mediaServiceToken", this.mediaServiceToken);

    // 获取告警类型每种个数
    this.getAlarmTypeAndCount(this.queryTime);
    this.getTotalAlarmData();
    this.getTodayALarmData();
    // 获取实时告警数据
    this.getCurrentAlarmInfoData();

    setTimeout(() => {
      this.getAlarmTypeAndCount(this.queryTime);
      this.getTotalAlarmData();
      this.getTodayALarmData();
      // 获取实时告警数据
      this.getCurrentAlarmInfoData();
    }, 500);

    this.initDataTimer = setInterval(this.initData, 60000);
    this.join();
    // let query = this.$route.query;
    // if (query.id !== undefined) {
    //   this.defaultExpandIds.push(query.id);
    // }
    // mqtt
    this.mqtt_url = "ws://cctv.hbrytech.cn:8083/mqtt";

    this.mqtt_options = {
      // Clean session
      clean: true,
      connectTimeout: 4000,
      // 认证信息
      // clientId: 'subscribe_client'+cameraIds[i-1].value,
      username: "RYtech",
      password: "1qaz@WSX",
    };
    this.$nextTick(() => {
      if (this.$refs.playback) {
        this.$refs.playback.getUserInfo();
      }
    });
    this.handle();

    this.shipNavigateStateList();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.initDataTimer);
    this.timer = null;
    this.$refs.supPlayer.closeAll();
  },
  mounted() {
    // console.log(new WebControl(),'WebControl....')
    this.timeFn();
    this.$refs.isMap.getUserFleetMethod();
    window.onresize = function () {
      if (isFull()) {
        // 全屏情况
        document.getElementById("fullScreenBtn").innerText = "退出全屏";
      } else {
        // 非全屏情况
        document.getElementById("fullScreenBtn").innerText = "全屏显示";
      }
    };
    let that = this;
    window.onresize = function () {
      if (that.$refs.livelive != null)
        console.log(
          "盒子宽度:",
          that.$refs.livelive.offsetWidth,
          "盒子高度:",
          that.$refs.livelive.offsetHeight
        );
    };
    // 获取用户信息，并保存
    this.getCompanyList();

    // 创建定时器
    this.timer = setInterval(() => {
      //  更新nvr 摄像头状态
      this.nvrList.forEach((nvr) => {
        let boxCode = nvr.split("_")[1];
        axios({
          url: this.MEDIA_URL + `/api/device/query/devices/${boxCode}/status`,
          method: "get",
          headers: {
            "Access-Token": this.mediaServiceToken,
          },
        }).then((result) => {
          let data = result.data;
          let deviceStatus = data.data.Online;
          let nvrDom = document.querySelector(`#${nvr} img`);
          let cameraList = this.cameraList.filter((camera) =>
            camera.includes(`${nvr}_`)
          );

          if (deviceStatus && boxCode) {
            // 判断当前设备是否存在
            if (deviceStatus === "ONLINE") {
              // p判断是否在线
              // 将nvr 摄像头设置为在线状态
              // nvrDom!=null?nvrDom.src = "/statics/nvr_online.svg":''
              // nvrDom!=null?nvrDom.title = "nvr在线":''

              cameraList.forEach((item) => {
                let cameraDom = document.querySelector(`#${item} img`);
                // cameraDom!=null?cameraDom.src = "/statics/camera_online.svg":''
                // cameraDom!=null?cameraDom.title = "摄像头在线":''
              });
              // } else {
              //   nvrDom!=null?nvrDom.src = "/statics/nvr_off_line.svg":''
              //   nvrDom!=null?nvrDom.title = "nvr不在线":""

              cameraList.forEach((item) => {
                let cameraDom = document.querySelector(`#${item} img`);
                // cameraDom!=null?cameraDom.src = "/statics/camera_off_line.svg":''
                // cameraDom!=null?cameraDom.title = "摄像头不在线":''
              });
            }
          } else {
            // nvrDom!=null? nvrDom.src = "/statics/nvr_off_line.svg":''
            // nvrDom!=null? nvrDom.title = "nvr不在线":''

            cameraList.forEach((item) => {
              let cameraDom = document.querySelector(`#${item} img`);
              // cameraDom!=null?cameraDom.src = "/statics/camera_off_line.svg":''
              // cameraDom!=null?cameraDom.title = "摄像头不在线":''
            });
          }
        });
      });

      // 更新Ai盒子状态
      this.aiBoxList.forEach((box) => {
        let boxDom = document.querySelector(`#${box} img`);
        let shipId = box.split("_")[1];

        axios({
          url: this.$root.BASE_URL + `/work/shipgpsinfo/${shipId}/status`,
          method: "get",
          headers: {
            authorization: this.token,
          },
        }).then((result) => {
          if (result.data.status === "online") {
            boxDom != null ? (boxDom.src = "/statics/box_online.svg") : "";
            boxDom != null ? (boxDom.title = "Ai智能终端在线") : "";
            // console.log(1);
          } else {
            boxDom != null ? (boxDom.src = "/statics/box_off_line.svg") : "";
            boxDom != null ? (boxDom.title = "Ai智能终端不在线") : "";
            // console.log(2);
          }
        });
      });
    }, 100000);
    // 船舶航行状态
    this.shipNavigationData();
    // this.drawShorePowerChart();
    // this.drawShorePowerChartTwo();
    // this.drawShorePowerChartThree();
  },
  destroyed() {
    this.$refs.recordVideoPlayer.destroy();
    window.removeEventListener("beforeunload", this.stopPlayRecord);
  },
  watch: {},
  methods: {
    // 视频回放
    toPlay() {
      if (this.monitorCode == null) {
        this.$message({
          type: "warning",
          message: "该摄像头没有监控点",
        });
        return;
      }
      let end = this.formatTime(this.endTime);
      let start = this.formatTime(this.startTime);

      console.log(this.monitorCode, end, start,'hikvisionType',this.hikvisionType)
      this.$refs.black.play(this.monitorCode, start, end,this.hikvisionType);
    },
    formatTime(time) {
      // 首先需要判断时间是否为空，如果为空则返回null
      if (time == null || time == "") {
        return null;
      }

      // 将时间字符串转换为Date对象
      let date = new Date(time);

      // 获取当前时区与UTC时间的时间差（以分钟为单位）
      let timezoneOffset = date.getTimezoneOffset();

      // 将时间差转换为毫秒数
      let offsetMilliseconds = timezoneOffset * 60 * 1000;

      // 调整时间，使其符合UTC时间
      date.setTime(date.getTime() - offsetMilliseconds);

      // 将调整后的时间转换为ISO 8601格式
      return date.toISOString();
    },

    changeSnIdSelect(item) {
      // console.log(item)
      this.monitorValue = item.label;
      this.monitorCode = item.value;
      this.dateSelectChange();
    },
    dateSelectChange(code) {
      this.startTime = this.formatTime(this.chooseDate + " 00:00:00");
      this.endTime = this.formatTime(this.chooseDate + " 23:59:59");
    },
    getColorByState(state) {
      switch (state) {
        case "锚泊":
          return "#00ffff"; // 锚泊时文字颜色为蓝色
        case "靠泊":
          return "yellow"; // 靠泊时文字颜色为黄色
        case "航行":
          return "#4fec7b"; // 航行时文字颜色为绿色
      }
    },
    // 船舶航行状态
    shipNavigationData() {
      axios({
        url:
          this.$root.BASE_URL +
          "/work/ship_info/bigView/shipNavigateStateNumber",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        let NavigationList = res.data.data;
        (this.navigate = NavigationList[0]),
          (this.mooring = NavigationList[1]),
          (this.anchor = NavigationList[2]),
          this.drawShorePowerChart();
        this.drawShorePowerChartTwo();
        this.drawShorePowerChartThree();
      });
    },
    dealPicUrl(url){
      // https://cctvs.hbrytech.cn:2123/prod-api/profile/upload/2025/10/21/8227be312b2a4e8082b6ced616c9133e.jpg
      if (url!=null){
        return this.$root.BASE_URL+url.substring(38,url.length)
      }
    },
    // 船舶航行状态
    drawShorePowerChart() {
      this.shorePowerChart = this.$echarts.init(this.$refs.shorePowerOne);

      let percentageString
      if (this.navigate.number!==0){
        percentageString = (this.navigate.rate * 100).toFixed(0) || 0;
      }else {
        percentageString = 0
      }


      let chartOptions = {
        title: {
          text: "{a|" + percentageString + "}{c|%}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: 24,
                color: "#4fec7b",
                fontWeight: 800,
              },

              c: {
                fontSize: 24,
                color: "#4fec7b",
              },
            },
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "外层细线",
            z: 0,
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.75,
                  startAngle: 0,
                  endAngle: 360,
                },
                style: {
                  stroke: "rgb(105,206,195)",
                  fill: "transparent",
                  lineWidth: 0.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: name,
            type: "pie",
            radius: ["65%", "75%"],
            silent: true,
            // clockwise: false,
            startAngle: 90,
            z: 1,
            zlevel: 0,
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: percentageString,
                name: "",
                itemStyle: {
                  normal: {
                    // color: "rgb(105,206,195)",
                    color: "#289a48",
                  },
                },
              },
              {
                value: 100 - percentageString,
                name: "",
                label: {
                  normal: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "rgba(0,0,0,0)",
                  },
                },
              },
            ],
          },
          {
            name: "刻度间隔",
            z: 2,
            type: "gauge",
            radius: "83%",
            center: ["50%", "50%"],
            startAngle: 0,
            endAngle: 359.9,
            splitNumber: 40,
            hoverAnimation: true,
            axisTick: {
              show: true,
              splitNumber: 1,
              length: "14%",
              lineStyle: {
                width: 2,
                color: "rgb(4,31,62)",
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            detail: {
              show: false,
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 90,
            radius: "64%",
            hoverAnimation: false,
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                labelLine: {
                  show: false,
                },
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                  {
                    offset: 1,
                    color: "rgba(55,70,130, 1)",
                  },
                  {
                    offset: 0,
                    color: "rgba(55,70,130, 0)",
                  },
                ]),
                shadowBlur: 10,
                // shadowColor: 'rgba(55,70,130, 1)'
              },
            },
            data: [
              {
                value: 100,
              },
            ],
          },
        ],
      };

      this.shorePowerChart = this.shorePowerChart.setOption(chartOptions);
    },
    // 锚泊 船舶
    drawShorePowerChartTwo() {
      this.shorePowerChartTwo = this.$echarts.init(this.$refs.shorePowerTwo);
      let percentageString
      if (this.mooring.number!==0){
        percentageString = (this.mooring.rate * 100).toFixed(0) || 0;
      }else {
        percentageString = 0
      }

      let chartOptionsTwo = {
        title: {
          text: "{a|" + percentageString + "}{c|%}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: 24,
                color: "#00ffff",
                fontWeight: 800,
              },

              c: {
                fontSize: 24,
                color: "#00ffff",
              },
            },
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "外层细线",
            z: 0,
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.75,
                  startAngle: 0,
                  endAngle: 360,
                },
                style: {
                  stroke: "rgb(105,206,195)",
                  fill: "transparent",
                  lineWidth: 0.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: name,
            type: "pie",
            radius: ["65%", "75%"],
            silent: true,
            // clockwise: false,
            startAngle: 90,
            z: 1,
            zlevel: 0,
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: percentageString,
                name: "",
                itemStyle: {
                  normal: {
                    color: "#00ffff",
                  },
                },
              },
              {
                value: 100 - percentageString,
                name: "",
                label: {
                  normal: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "rgba(0,0,0,0)",
                  },
                },
              },
            ],
          },
          {
            name: "刻度间隔",
            z: 2,
            type: "gauge",
            radius: "83%",
            center: ["50%", "50%"],
            startAngle: 0,
            endAngle: 359.9,
            splitNumber: 40,
            hoverAnimation: true,
            axisTick: {
              show: true,
              splitNumber: 1,
              length: "14%",
              lineStyle: {
                width: 2,
                color: "rgb(4,31,62)",
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            detail: {
              show: false,
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 90,
            radius: "64%",
            hoverAnimation: false,
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                labelLine: {
                  show: false,
                },
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                  {
                    offset: 1,
                    color: "rgba(55,70,130, 1)",
                  },
                  {
                    offset: 0,
                    color: "rgba(55,70,130, 0)",
                  },
                ]),
                shadowBlur: 10,
                // shadowColor: 'rgba(55,70,130, 1)'
              },
            },
            data: [
              {
                value: 100,
              },
            ],
          },
        ],
      };
      this.shorePowerChartTwo =
        this.shorePowerChartTwo.setOption(chartOptionsTwo);
    },
    drawShorePowerChartThree() {
      this.shorePowerChartThree = this.$echarts.init(
        this.$refs.shorePowerThree
      );
      let percentageString
      if (this.anchor.number!==0){
        percentageString = (this.anchor.rate * 100).toFixed(0) || 0;
      }else {
        percentageString = 0
      }

      let chartOptionsThree = {
        title: {
          text: "{a|" + percentageString + "}{c|%}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: 24,
                color: "yellow",
                fontWeight: 800,
              },

              c: {
                fontSize: 24,
                color: "yellow",
              },
            },
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: "外层细线",
            z: 0,
            type: "custom",
            coordinateSystem: "none",
            renderItem: function (params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.75,
                  startAngle: 0,
                  endAngle: 360,
                },
                style: {
                  stroke: "rgb(105,206,195)",
                  fill: "transparent",
                  lineWidth: 0.5,
                },
                silent: true,
              };
            },
            data: [0],
          },
          {
            name: name,
            type: "pie",
            radius: ["65%", "75%"],
            silent: true,
            // clockwise: false,
            startAngle: 90,
            z: 1,
            zlevel: 0,
            label: {
              normal: {
                position: "center",
              },
            },
            data: [
              {
                value: percentageString,
                name: "",
                itemStyle: {
                  normal: {
                    color: "yellow",
                  },
                },
              },
              {
                value: 100 - percentageString,
                name: "",
                label: {
                  normal: {
                    show: false,
                  },
                },
                itemStyle: {
                  normal: {
                    color: "rgba(0,0,0,0)",
                  },
                },
              },
            ],
          },
          {
            name: "刻度间隔",
            z: 2,
            type: "gauge",
            radius: "83%",
            center: ["50%", "50%"],
            startAngle: 0,
            endAngle: 359.9,
            splitNumber: 40,
            hoverAnimation: true,
            axisTick: {
              show: true,
              splitNumber: 1,
              length: "14%",
              lineStyle: {
                width: 2,
                color: "rgb(4,31,62)",
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                opacity: 0,
              },
            },
            detail: {
              show: false,
            },
            data: [100],
          },
          {
            name: "",
            type: "pie",
            startAngle: 90,
            radius: "64%",
            hoverAnimation: false,
            center: ["50%", "50%"],
            itemStyle: {
              normal: {
                labelLine: {
                  show: false,
                },
                color: new echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                  {
                    offset: 1,
                    color: "rgba(55,70,130, 1)",
                  },
                  {
                    offset: 0,
                    color: "rgba(55,70,130, 0)",
                  },
                ]),
                shadowBlur: 10,
                // shadowColor: 'rgba(55,70,130, 1)'
              },
            },
            data: [
              {
                value: 100,
              },
            ],
          },
        ],
      };
      this.shorePowerChartThree =
        this.shorePowerChartThree.setOption(chartOptionsThree);
    },
    // 右下饼图
    createPieChart(alarmTypeList, alarmCountList) {
      let el = document.getElementById("pieChartContainer");
      if (alarmTypeList.length <= 0 && alarmCountList.length <= 0) {
        echarts.init(el).dispose(); // 销毁实例
        return;
      }
      // 基于准备好的dom，初始化echarts实例
      let EChart = echarts.init(el);
      let sum = alarmCountList.reduce((cur, pre) => {
        return cur + pre;
      }, 0);
      let data = [];
      let displayedLegendData = [];
      let legendData = [];
      var color = [
        "#00ffff",
        "#409B5C",
        "#006ced",
        "#ffe000",
        "#ffa800",
        "#ff5b00",
        "#ff3000",
      ];
      for (var i = 0; i < alarmCountList.length; i++) {
        let name = alarmTypeList[i] + "  " + alarmCountList[i];
        legendData.push(name);
        data.push(
          {
            value: alarmCountList[i],
            name: name,
            itemStyle: {
              borderWidth: 0,
              borderRadius: 10,
              shadowBlur: 10,
              borderColor: color[i],
              shadowColor: color[i],
            },
          },
          {
            value: sum / 100, // 控制每个环形之间的间隙
            name: "",
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              color: "rgba(0, 0, 0, 0)",
              borderColor: "rgba(0, 0, 0, 0)",
              borderWidth: 0,
            },
          }
        );
        displayedLegendData = legendData;
      }
      let seriesOption = [
        {
          name: "",
          type: "pie",
          clockwise: false,
          radius: ["35%", "55%"],
          center: ["13%", "50%"],

          emphasis: {
            scale: false,
          },
          label: {
            show: false,
          },
          data: data,
        },
      ];
      let option = {
        title: {
          text: "告警总量",
          subtext: sum,
          textStyle: {
            color: "#19E1E3",
            fontSize: 12,
            padding: [0, 0, 25, 0],
          },
          subtextStyle: {
            fontSize: 15,
            fontWeight: "bolder",
            color: "#19E1E3",
            padding: [0, 0, 25],
          },
          x: "12%",
          y: "38%",
          textAlign: "center",
        },
        color: color,
        tooltip: {
          show: false,
        },
        legend: {
          icon: "rect",
          itemWidth: 12,
          itemHeight: 8,
          itemStyle: {
            borderWidth: 3,
          },
          orient: "vertical",
          data: displayedLegendData,
          right: "0%",
          top: "center",
          align: "left",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            padding: [10, 0, 0, 0],
          },
          itemGap: 1, // 图例之间的间隔
        },
        toolbox: {
          show: false,
        },
        series: seriesOption,
      };
      EChart.setOption(option, true);
    },

    //回放
    formatStartTime(dateTime) {
      return moment(dateTime).format("HH:mm:ss");
    },
    formatEndTime(dateTime) {
      return moment(dateTime).format("HH:mm:ss");
    },
    videoError: function (e) {
      console.log("播放器错误：" + JSON.stringify(e));
    },
    back() {
      this.selectPlayPick = false;
      this.resetPlayer();
      // this.$refs.recordVideoPlayer.destroy();
    },
    resetPlayer() {
      this.chooseDate = null;
      this.timeRange = null;
      this.playTime = null;
      this.sliderMax = 86400;
      this.sliderMIn = 0;
      this.detailFiles = [];
    },
    checkedFile(file) {
      console.log(file, "file");
      this.chooseFile = file;
      this.setTime(file.startTime, file.endTime);
      // 开始回放
      this.playRecord();
    },
    playRecord: function () {
      if (this.streamId !== "") {
        this.stopPlayRecord(() => {
          this.streamId = "";
          this.playRecord();
        });
      } else {
        axios({
          method: "get",
          url:
            this.MEDIA_URL +
            "/api/playback/start/" +
            this.deviceId +
            "/" +
            this.channelId +
            "?startTime=" +
            this.startTime +
            "&endTime=" +
            this.endTime,
          headers: {
            "Access-Token": this.mediaServiceToken,
          },
        }).then((res) => {
          if (res.data.code === 0) {
            this.streamInfo = res.data.data;
            this.app = this.streamInfo.app;
            this.streamId = this.streamInfo.stream;
            this.mediaServerId = this.streamInfo.mediaServerId;
            this.ssrc = this.streamInfo.ssrc;
            this.videoUrl = res.data.data.wss_flv;
            this.hasAudio =
              this.streamInfo.tracks && this.streamInfo.tracks.length > 1;
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    gbPlay() {
      console.log("前端控制：播放");
      axios({
        method: "get",
        url: this.MEDIA_URL + "/api/playback/resume/" + this.streamId,
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      }).then((res) => {
        this.$refs["recordVideoPlayer"].load(
          this.videoUrl,
          `${this.deviceId}_${this.channelId}`
        );
      });
    },
    gbPause() {
      console.log("前端控制：暂停");
      axios({
        method: "get",
        url: this.MEDIA_URL + "/api/playback/pause/" + this.streamId,
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      }).then(function (res) {
        // TODO 给播放器添加暂停图层
      });
    },
    gbScale(command) {
      console.log("前端控制：倍速 " + command);
      axios({
        method: "get",
        url: this.MEDIA_URL + `/api/playback/speed/${this.streamId}/${command}`,
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      }).then(function (res) { });
    },
    stopPlayRecord: function (callback) {
      console.log("停止录像回放");
      if (this.streamId !== "") {
        this.$refs["recordVideoPlayer"].pause();
        this.videoUrl = "";
        axios({
          method: "get",
          url:
            this.MEDIA_URL +
            "/api/playback/stop/" +
            this.deviceId +
            "/" +
            this.channelId +
            "/" +
            this.streamId,
          headers: {
            "Access-Token": this.mediaServiceToken,
          },
        }).then(function (res) {
          if (callback) callback();
        });
      }
    },
    getDataWidth(item) {
      let timeForFile = this.getTimeForFile(item);
      let result = timeForFile[2] / ((this.sliderMax - this.sliderMIn) * 1000);
      return result * 100;
    },
    getDataLeft(item) {
      let timeForFile = this.getTimeForFile(item);
      let differenceTime =
        timeForFile[0].getTime() -
        new Date(this.chooseDate + " 00:00:00").getTime();
      return (
        parseFloat(
          (differenceTime - this.sliderMIn * 1000) /
          ((this.sliderMax - this.sliderMIn) * 1000)
        ) * 100
      );
    },
    timePickerChange: function (val) {
      this.setTime(val[0], val[1]);
    },
    playTimeChange(val) {
      console.log(val);

      let startTimeStr = moment(
        new Date(this.chooseDate + " 00:00:00").getTime() + val[0] * 1000
      ).format("YYYY-MM-DD HH:mm:ss");
      let endTimeStr = moment(
        new Date(this.chooseDate + " 00:00:00").getTime() + val[1] * 1000
      ).format("YYYY-MM-DD HH:mm:ss");

      this.setTime(startTimeStr, endTimeStr);

      this.playRecord();
    },
    setSliderFit() {
      if (this.sliderMIn === 0 && this.sliderMax === 86400) {
        if (this.detailFiles.length > 0) {
          let timeForFile = this.getTimeForFile(this.detailFiles[0]);
          let lastTimeForFile = this.getTimeForFile(
            this.detailFiles[this.detailFiles.length - 1]
          );
          let timeNum =
            timeForFile[0].getTime() -
            new Date(this.chooseDate + " " + "00:00:00").getTime();
          let lastTimeNum =
            lastTimeForFile[1].getTime() -
            new Date(this.chooseDate + " " + "00:00:00").getTime();

          this.playTime = parseInt(timeNum / 1000);
          this.sliderMIn = parseInt(
            timeNum / 1000 - ((timeNum / 1000) % (60 * 60))
          );
          this.sliderMax =
            parseInt(lastTimeNum / 1000 - ((lastTimeNum / 1000) % (60 * 60))) +
            60 * 60;

          this.playTime = [this.sliderMIn, this.sliderMax];
        }
      } else {
        this.sliderMIn = 0;
        this.sliderMax = 86400;
      }
    },
    getTimeForFile(file) {
      let startTime = new Date(file.startTime);
      let endTime = new Date(file.endTime);
      return [startTime, endTime, endTime.getTime() - startTime.getTime()];
    },
    playTimeFormat(val) {
      let h = parseInt(val / 3600);
      let m = parseInt((val - h * 3600) / 60);
      let s = parseInt(val - h * 3600 - m * 60);

      let hStr = h;
      let mStr = m;
      let sStr = s;
      if (h < 10) {
        hStr = "0" + hStr;
      }
      if (m < 10) {
        mStr = "0" + mStr;
        s;
      }
      if (s < 10) {
        sStr = "0" + sStr;
      }
      return hStr + ":" + mStr + ":" + sStr;
    },
    goBack() {
      // 如果正在进行录像回放则，发送停止
      if (this.streamId !== "") {
        this.stopPlayRecord(() => {
          this.streamId = "";
        });
      }
      window.history.go(-1);
    },
    //
    openHandle() {
      this.flag = !this.flag;
    },
    // 点击按钮进行切换
    showWaitList(index) {
      this.activeTab = index;
      this.handle();
    },
    handle() {
      if (this.activeTab == 0) {
        this.$nextTick(() => {
          this.$refs.noticetoMariner.getInfoList();
        });
      } else if (this.activeTab == 1) {
        this.$nextTick(() => {
          this.$refs.navigationNotice.getInfoList();
        });
      } else if (this.activeTab == 2) {
        this.$nextTick(() => {
          this.$refs.levelAnnouncement.getInfoList();
        });
      } else if (this.activeTab == 3) {
        this.$nextTick(() => {
          this.$refs.waterwayDimension.getInfoList();
        });
      } else if (this.activeTab == 4) {
        this.$nextTick(() => {
          this.$refs.weatherForecastList.getInfoList();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.announcement.getInfoList();
        });
      }
    },
    // 跳转告警详情
    goDetail(item) {
      console.log(item, "itttttttttt");
      this.detailDialog = true;
      // const id = "GJ20240620110338817";
      this.getAlarm_table_info(item.alarmCode);
    },

    getAlarm_table_info(id) {
      axios({
        url: this.$root.BASE_URL + `/work/alarm_table/info/${id}`,
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        if (
          res.data.data.alarmVideoUrl != null &&
          res.data.data.alarmVideoUrl !== ""
        ) {
          res.data.data.alarmVideoUrl = res.data.data.alarmVideoUrl.replace(
            ".avi",
            ".mp4"
          );
        }
        this.form = res.data.data;
        console.log(res, "GJ202406200936230");
        if (this.form.alarmHandleState === "1") {
          this.flag2 = false;
        }
      });
    },
    // 处置提交
    cSubit() {
      if (!this.corm.alarmHandleRes) {
        return this.$message({
          message: "请填写处置结果",
          type: "none",
        });
      }

      this.corm.alarmId = this.form.alarmId;
      axios({
        url: this.$root.BASE_URL + "/work/alarm_handle/update/handle",
        method: "post",
        data: this.corm,
        headers: {
          authorization: this.token,
        },
      }).then((response) => {
        if (response.data.code == 200) {
          this.flag = false;
          this.$message({
            message: "处置成功",
            type: "success",
          });
          this.getAlarm_table_info(this.form.alarmId);
        }
      });
    },
    //
    changeText(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getCompanyList() {
      axios({
        url: this.$root.BASE_URL + "/system/user/profile",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        this.userInfo = res.data.data;
        // 查询公司-船舶/码头-摄像头信息
        this.getList();
      });
    },
    // 获取公司-船舶-摄像头信息
    getList() {
      let data = {
        roleId: this.userInfo.roles[0].roleId,
        userId: this.userInfo.userId,
        deptId: this.userInfo.deptId,
      };
      axios({
        url: this.$root.BASE_URL + "/work/sy/company/list",
        method: "post",
        data,
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        this.companyList = res.data.data;
        let boxStr = "box_";
        this.companyList.forEach((company) => {
          company.children.forEach((ship) => {
            // TODO 添加nvr
            // console.log(ship.boxCode);
            let nvrStr = `nvr_${ship.boxCode}_${ship.value}`;
            this.nvrList.push(nvrStr);

            // TODO 添加盒子
            boxStr += ship.value;
            this.aiBoxList.push(boxStr);
            boxStr = "box_";

            ship.children.forEach((camera) => {
              if (!camera) return;

              let nvrStr = this.nvrList[this.nvrList.length - 1];
              // console.log(camera);
              // 添加摄像头
              nvrStr += `_${camera.value}`;
              this.cameraList.push(nvrStr);
            });
            nvrStr = "nvr_";
          });
        });

        this.companyList.forEach((p) => {
          p.children.forEach((q) => {
            q.icon = "playImg";
            if (q.children[0] == null) {
              q.children = null;
            } else {
              q.children.forEach((qq) => {
                qq.icon = "aiMonitor";
              });
            }
          });
        });
      });
    },
    // 回放
    // 公司列表树 处理方法
    playBackClick(node) {
      /*
      // 判断是否是叶子结点
      if (data.children !== undefined) {
        return;
      }
      // 清空默认节点
      this.defaultExpandIds = [];
      // 请求回放数据
      this.deviceId = e.parent.data.boxCode;
      this.channelId = data.value;
      this.chooseDate = moment().format("YYYY-MM-DD");
      console.log(this.chooseDate, "this.chooseDate");
      this.dateChange();
      // 存放
      this.defaultExpandIds.push(e.parent.data.value);
      this.selectPlayPick = true;
      this.companyName = e.parent.parent.data.label;
      this.shipName = e.parent.data.label;
      this.position = data.label;
      */
      // 判断是否是叶子结点
      if (node.children !== undefined) {
        return;
      }
      this.monitorOptions = [];
      let children = node.label;
      let fu = this.$refs.tree.getNode(node).parent.data.label;
      let list = this.$refs.tree.getNode(node).parent.data.children;
      this.hikvisionType=this.$refs.tree.getNode(node).parent.data.hikvisionType
      console.log(this.$refs.tree.getNode(node).parent.data,'this.$refs.tree.getNode(node).parent.data')
      list.forEach((item) => {
        let obj = {
          value: item.monitorPointCode,
          label: item.label,
        };
        this.monitorOptions.push(obj);
      });
      this.monitorValue = node.label;
      this.monitorDetail = fu;

      this.selectPlayPick = true;
      this.startTime = moment().format("YYYY-MM-DD hh:mm:ss");
      this.endTime = moment().format("YYYY-MM-DD hh:mm:ss");
      this.monitorCode = node.monitorPointCode;
      // this.dateStartChange()
      // this.dateEndChange()
    },
    dateChange() {
      if (!this.chooseDate) {
        return;
      }
      this.setTime(
        this.chooseDate + " 00:00:00",
        this.chooseDate + " 23:59:59"
      );
      this.detailFiles = [];
      axios({
        method: "get",
        url:
          this.MEDIA_URL +
          "/api/gb_record/query/" +
          this.deviceId +
          "/" +
          this.channelId +
          "?startTime=" +
          this.startTime +
          "&endTime=" +
          this.endTime,
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      })
        .then((res) => {
          if (res.data.code === 0) {
            // 处理时间信息
            this.$nextTick(() => {
              this.detailFiles = res.data.data.recordList;
            });

            // console.log(res.data.data.recordList, "resssssssssss");
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((e) => { });
    },
    setTime: function (startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      let start =
        (new Date(this.startTime).getTime() -
          new Date(this.chooseDate + " 00:00:00").getTime()) /
        1000;
      let end =
        (new Date(this.endTime).getTime() -
          new Date(this.chooseDate + " 00:00:00").getTime()) /
        1000;
      // console.log(start, "start");
      // console.log(end, "start");
      this.playTime = [start, end];
      this.timeRange = [startTime, endTime];
    },
    // 直播
    join() {
      axios({
        url: this.$root.BASE_URL + "/system/user/profile",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        const wsuri = this.url + "/" + res.data.data.userId;
        this.ws = new WebSocket(wsuri);
        const self = this;
        this.ws.onopen = function (event) {
          // console.log("已经打开连接!");
        };
        this.ws.onmessage = function (event) {
          self.text_content = event.data + "\n";
          if (self.text_content.length > 8) {
            var tData = JSON.parse(self.text_content);
            self.$notify({
              title: "告警",
              dangerouslyUseHTMLString: true,
              // message: `船舶名称:${tData.shipName}  警告编码:${tData.alarmId}  警告类型${tData.alarmType},警告等级${tData.alarmRank}`,
              message: `
                    <span>船舶名称:<span style=color:#419EFF>${tData.shipName}</span><br/>
                    <span>警告等级:<span style=color:#ff0000>${tData.alarmRank}</span><br/>
                    <span>告警编码:<span style=color:#fed761>${tData.alarmId}</span><br/>
                    <span>警告类型:<span style=color:#ff6f00>${tData.alarmType}</span>
                    <span>警告标题:<span style=color:#ff6f00>${tData.alarmTitle}</span>
                    `,
              onClick: () => {
                // 2023年8月24日16:45:54
                self.$router.push({
                  path: "/work/alarm_table_detail/index",
                  query: { alarmId: tData.alarmId },
                }); // 跳转详情页面
              },
              duration: 8000,
              type: "warning",
            });
            self.audio.autoplay = true;
            self.audio.src = self.successUrl;
          }
        };
        this.ws.onclose = function (event) {
          console.log("已经关闭连接!");
        };
      });
    },
        playAll(data) {
          this.show = false;
          // this.playAll(data)
      let list = []
      console.log(data,'播放全部')
      this.hikvisionType=data.hikvisionType
      data.children?.forEach(item => {
        /**
         * 播放全部时就需要记住甲板编码，然后再回调消息中判断是否是甲板进行画面渲染。
         */

        if (item.monitorPointCode != null) {
          if(item.label.includes('甲板')){
          // this.deck_code=item.monitorPointCode

        }
          list.push(item.monitorPointCode)
        }
      })
      let number //窗格数

      if (list?.length <= 1) {
        number = '1x1'
      } else if (list?.length <= 2) {
        number = '1x2'
      } else if (list?.length <= 3) {
        number = '1+2'
      } else if (list?.length <= 4) {
        number = '2x2'
      } else if (list?.length <= 6) {
        number = '1+5'
      } else if (list?.length <= 7) {
        number = '3+4'
      } else if (list?.length <= 8) {
        number = '1+7'
      } else if (list?.length <= 9) {
        number = '3x3'
      } else if (list?.length <= 10) {
        number = '1+9'
      } else if (list?.length <= 13) {
        number = '4+9'
      } else if (list?.length <= 14) {
        number = '1+1+12'
      } else if (list?.length <= 16) {
        number = '4x4'
      } else if (list?.length <= 17) {
        number = '1+16'
      } else if (list?.length <= 25) {

        number = '5x5'
      } else {
        list = list.slice(0, 26)

        this.$message({
          message: '播放窗格最大5x5，播放部分视频',
          type: 'warning'
        })
      }

      if (list.length == 0) {
        this.$message({
          message: '设备暂无监控点',
          type: 'warning'
        })
      } else {
        console.log(1111)
          if (!this.stopAll) {
            console.log(222)
          this.$refs.live.setNumber(number, list)
          this.stopAll = true
        } else {
          this.$refs.live.stopAllPreview()
          this.$refs.live.setNumber(number, list)
          this.stopAll = false
        }


      }


      // this.$refs.live.playAll(list)
      // console.log('播放全部....',data)
    },
    handleNodeClick: function (data, e) {
      this.show = false;

      if(data.icon=="playImg"){
        this.hikvisionType=data.hikvisionType
      }
      console.log(data.hikvisionType,data,'*********')
      if (data.icon == "aiMonitor") {
        this.cameraIndexCode = data.monitorPointCode;
        if (data.monitorPointCode != null) {
          // if (this.lunTitle == '暂停轮巡') {
          //   this.$refs.live.clear()
          //   this.lunTitle = '轮巡'
          // }
          // if (this.comLunXunTitle == '暂停轮巡') {
          //   this.$refs.live.clear()
          //   this.comLunXunTitle = '轮巡'
          // }
          console.log(data,'****play*****')
          this.$refs.live.play(data.monitorPointCode);
        } else {
          this.$message({
            message: "设备暂无监控点",
            type: "warning",
          });
        }
      }
      /**
       * 根据点击船舶进行请求渲染
       * monitorPointCode：null时传'',并创建arryList数组，将对应的value值存入
       */
      if (data.children?.length != 0 && data.icon == "playImg") {
        console.log(data, "handleNodeClick....");
        this.arryList = [];
        let list = [];
        data.children.forEach((item) => {
          if (item.monitorPointCode != null) {
            list.push(item.monitorPointCode);
          } else {
            list.push("");
          }
          let obj = {
            value: item.value,
          };
          this.arryList.push(obj);
        });
        this.getStatus(list, data.boxCode);
      }
      // this.selectMonitor(data, e);

      // this.selectMediaPlayer(data, e);
    },
    async getStatus(list, boxCode) {
      axios({
        url: "http://cctv.hbrytech.cn:2123/prod-api/work/shipVideo/fetch/device/status",
        method: "post",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
        data: list,
      })
        .then((res) => {
          /*
        设置nvr状态：有1则在线，无 则不在线
        */

          let nvrDom = document.querySelector(`#nvr_${boxCode} img`);
          if (res.data.data.includes(1)) {
            // 将nvr 摄像头设置为在线状态
            nvrDom != null ? (nvrDom.src = "/statics/nvr_online.svg") : "";
            nvrDom != null ? (nvrDom.title = "nvr在线") : "";
          } else {
            nvrDom != null ? (nvrDom.src = "/statics/nvr_off_line.svg") : "";
            nvrDom != null ? (nvrDom.title = "nvr不在线") : "";
          }
          this.setDom(res.data.data);
        })
        .catch((err) => { });
    },
    /*
    拿到数据进行渲染 code:1在线，code：0不在线
    data:['0','1']，因为data数据返回是有顺序的所以arryList根据index进行创建属性code:状态值
    */

    setDom(data) {
      data.forEach((item, index) => {
        this.arryList[index].code = item;
      });

      this.arryList.forEach((item) => {
        let cameraDom = document.querySelector(`#camer_${item.value} img`);

        if (item.code == 1) {
          cameraDom != null
            ? (cameraDom.src = "/statics/camera_online.svg")
            : "";
          cameraDom != null ? (cameraDom.title = "摄像头在线") : "";
        }
        if (item.code == 0) {
          cameraDom != null
            ? (cameraDom.src = "/statics/camera_off_line.svg")
            : "";
          cameraDom != null ? (cameraDom.title = "摄像头不在线") : "";
        }
      });
      //
    },

    // item 当前节点对象
    async selectMediaPlayer(item, e) {
      // 判断当时节点是否为叶子节点
      if (item.children !== undefined) {
        return;
      }

      // 判断当前是否为重复点击
      let channelId = item.value;
      let deviceId = e.parent.data.boxCode;
      let stream = await this.getMediaStreamAddress(deviceId, channelId);
      if (stream) {
        // TODO 获取当前摄像头下的Dom对象 将 img属性变成null tc-player splitScreenNum
        // let playerImg = document.querySelector('#tc-player' + this.$refs.supPlayer.getCurrentSplitNum() + ' img');
        // playerImg.style.visibility = 'hidden';
        this.$refs.supPlayer.play(stream, `${deviceId}_${channelId}`);
      } else {
        this.$message.error(`没有可播放视频`);
      }
    },
    async getMediaStreamAddress(deviceId, channelId) {
      // TODO 请求流媒体服务器
      let stream = null;
      let result = await axios({
        url: this.MEDIA_URL + `/api/play/start/${deviceId}/${channelId}`,
        method: "get",
        headers: {
          "Access-Token": this.mediaServiceToken,
        },
      });
      if (result.data.code == 0) {
        return result.data.data.wss_flv;
      }
    },
    // 点击摄像头列表，选择摄像头
    async selectMonitor(item, e) {
      // 判断是否是叶子结点
      if (item.children !== undefined) {
        return;
      }
      // 得到该叶子结点的公司
      item.company = e.parent.parent.data.label;
      item.boxCode = e.parent.data.boxCode;
      let box, dom;

      // 如果当前类型是1分屏
      if (this.type === 1) {
        dom = document.getElementById("flv1");
        this.showBox[0].model = item;
        box = this.showBox[0];
      } else {
        // 如果当前类型是4分、9分屏
        for (let i = 0; i < this.showBox.length; i++) {
          if (this.showBox[i].moniter === "") {
            this.showBox[i].model = item;
            dom = document.getElementById(this.showBox[i].id);
            box = this.showBox[i];
            break;
          }
        }
      }

      // 通过上述判断没得到box，则是没有空余的了
      if (box === null || box === undefined) {
        this.$message({
          message: "暂无可用通道",
          type: "warning",
        });
        return;
      }

      // 判断该摄像头是不是点过了
      for (let i = 0; i < this.showBox.length; i++) {
        if (this.showBox[i].moniter === item.value) {
          this.$message({
            message: "该摄像头已在播流通道中",
            type: "warning",
          });
          return;
        }
      }

      // 发请求，得到通道地址
      // 参数：摄像头id，所属公司
      let data = {
        cameraCode: box.model.value,
        channelCompanyName: box.model.company,
        gCameraCode: "",
      };

      if (res.code === 200) {
        if (this.type === 1) {
          // 当前是一分屏时，发请求，关闭其他摄像头
          // 参数：摄像头id
          this.companyList.forEach((p) => {
            p.children.forEach((q) => {
              if (q.children !== null) {
                q.children.forEach((i) => {
                  if (i.state === 1) {
                    // mqtt 关流
                    const client = mqtt.connect(
                      this.mqtt_url,
                      this.mqtt_options
                    );
                    client.on("connect", function () {
                      // console.log('mqtt/live/'+i.boxCode+'/'+i.value)
                      // 订阅主题
                      client.subscribe(
                        "mqtt/live/" + i.boxCode + "/" + i.value,
                        function (err) {
                          if (!err) {
                            // 发布消息
                            client.publish(
                              "mqtt/live/" + i.boxCode + "/" + i.value,
                              "false",
                              { qos: 2 }
                            );
                            client.end();
                            i.state = 0;
                          }
                        }
                      );
                    });
                  }
                });
              }
            });
          });
        }

        // 开启成功，标记该摄像头被开启
        item.state = 1;

        // 数据模型
        // 更换src
        this.showBox.forEach((p) => {
          if (p.id === box.id) {
            // flv
            let id = box.id;
            let number = id.substring(3, box.id.length);
            if (number > 6) {
              p.src =
                "http://cctvs.hbrytech.cn:8080/live/" +
                box.model.value +
                ".flv";
            } else {
              p.src =
                "http://cctv.hbrytech.cn:8080/live/" + box.model.value + ".flv";
            }
            p.moniter = box.model.value;
            p.boxCode = item.boxCode;
            // console.log(p)
          }
        });

        // mqtt
        const client = mqtt.connect(this.mqtt_url, this.mqtt_options);

        client.on("connect", function () {
          // console.log('Connected')
          // console.log('mqtt/live/'+item.boxCode+'/'+box.model.value)
          // 订阅主题
          client.subscribe(
            "mqtt/live/" + item.boxCode + "/" + box.model.value,
            function (err) {
              // console.log(err)
              if (!err) {
                // 发布消息
                client.publish(
                  "mqtt/live/" + item.boxCode + "/" + box.model.value,
                  "true",
                  { qos: 2 }
                );
                client.end();
              }
            }
          );
        });
      } else {
      }

      // 刷新视频
      dom.outerHTML =
        '<video id="' +
        box.id +
        '" src="' +
        box.src +
        '" class="video-js vjs-big-play-centered vjs-fluid" controls>\n' +
        '<source src="' +
        box.src +
        '" type="video/x-flv"/>\n' +
        "</video>";

      setTimeout(() => {
        this.show_single(box);
      }, 1000);
    },
    // 选择某一摄像头时加载单个video
    show_single(box) {
      box.isReload = 0;
      if (this[`${box.id}`] !== null) {
        this[`${box.id}`].dispose();
        let dom = document.getElementById(box.id);
        // 刷新视频
        dom.outerHTML =
          '<video id="' +
          box.id +
          '" class="video-js vjs-big-play-centered vjs-fluid" controls>\n' +
          "</video>";
      }

      let option = {
        autoplay: "autoplay", //自动播放
        controls: true, //用户可以与之交互的控件
        loop: true, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        fullscreen: {
          options: { navigationUI: "hide" },
        },
        techOrder: ["html5", "flvjs"], // 兼容顺序
        flvjs: {
          mediaDataSource: {
            isLive: false,
            cors: true,
            withCredentials: false,
          },
        },
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        fluid: true, // 自适应宽高
        sources: [{ src: box.src, type: "video/x-flv" }],
        playbackRates: [0.5, 1, 1.5, 2],
      };
      this[`${box.id}`] = Videojs(document.querySelector(box.url), option);
      this[`${box.id}`].play();
      let that = this;
      setTimeout(function () {
        that.waitingMethod(box);
      }, 30000);

      this[`${box.id}`].on("canplaythrough", function () {
        console.log("视频源数据加载完成");
        that.canplaythroughMethod(box);
      });
    },
    // TODO 开启全部
    openAllMedia(item, e) {
      let nodeNum = e.childNodes.length;
      let inputSplitNum = 1;
      if (1 < nodeNum && nodeNum <= 4) {
        inputSplitNum = 4;
      } else if (nodeNum <= 9) {
        inputSplitNum = 9;
      } else {
        inputSplitNum = 16;
      }
      console.log(inputSplitNum);
      let currentSplitNum = this.$refs.supPlayer.getCurrentSplitNum();
      if (currentSplitNum === 1) {
        this.$confirm("当前为单屏模式，是否切换到多屏?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.supPlayer.closeAll();
            this.$refs.supPlayer.splitScreen(inputSplitNum);
            let deviceId = item.boxCode;
            let playerArray = e.childNodes;
            for (let index = 0; index < playerArray.length; index++) {
              let channelId = playerArray[index].data.value;
              axios({
                url:
                  this.MEDIA_URL + `/api/play/start/${deviceId}/${channelId}`,
                method: "get",
                headers: {
                  "Access-Token": this.mediaServiceToken,
                },
              }).then((result) => {
                if (result.data.code === 0) {
                  let stream = result.data.data.wss_flv;
                  console.log("#tc-player" + (index + 1) + " img");
                  let playerImg = document.querySelector(
                    "#tc-player" + (index + 1) + " img"
                  );
                  playerImg.style.visibility = "hidden";
                  this.$refs.supPlayer.playAtIndex(
                    index + 1,
                    stream,
                    `${deviceId}_${channelId}`
                  );
                }
              });
            }
          })
          .catch(() => {
            // TODO 取消
            this.$refs.supPlayer.splitScreen(1);
          });
      } else {
        this.$refs.supPlayer.closeAll();
        this.$refs.supPlayer.splitScreen(inputSplitNum);
        let deviceId = item.boxCode;
        let playerArray = e.childNodes;
        for (let index = 0; index < playerArray.length; index++) {
          let channelId = playerArray[index].data.value;
          axios({
            url: this.MEDIA_URL + `/api/play/start/${deviceId}/${channelId}`,
            method: "get",
            headers: {
              "Access-Token": this.mediaServiceToken,
            },
          }).then((result) => {
            if (result.data.code === 0) {
              console.log(result);

              let playerImg = document.querySelector(
                "#tc-player" + (index + 1) + " img"
              );
              playerImg.style.visibility = "hidden";

              let stream = result.data.data.wss_flv;
              this.$refs.supPlayer.playAtIndex(
                index + 1,
                stream,
                `${deviceId}_${channelId}`
              );
            }
          });
        }
      }
    },

    openDialog(id) {
      // 开启弹框
      this.isShow = true;
      this.$nextTick(() => {
        // 请求后端获取 详细内容
        axios({
          url: this.$root.BASE_URL + `/work/notice/ntm/${id}`,
          method: "get",
          headers: {
            authorization: this.token,
          },
        }).then((res) => {
          let dialogDom = document.querySelector("#html_container");
          dialogDom.insertAdjacentHTML("afterbegin", res.data.data.content);
        });
      });
    },

    openOne(id) { },
    closeDialog() {
      // 关闭弹框
      this.isShow = false;
    },
    //

    toggleFull,
    initData() {
      // 获取告警类型每种个数
      this.getAlarmTypeAndCount(this.queryTime);
      this.getTotalAlarmData();
      this.getTodayALarmData();
      // 获取实时告警数据
      this.getCurrentAlarmInfoData();
    },
    // 获取告警数据
    getCurrentAlarmInfoData() {
      axios({
        url: this.$root.BASE_URL + "/work/alarm_table/current",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        res = res.data;
        this.currentDataList = res.data;
      });
    },
    // 总的告警数据
    getTotalAlarmData() {
      axios({
        url: this.$root.BASE_URL + "/work/alarm_handle/total",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        res = res.data;
        this.totalAlarmCount.old = this.totalAlarmCount.new;
        this.totalAlarmCount.new = res.data.totalAlarmCount;

        this.totalProcessedAlarmCount.old = this.totalProcessedAlarmCount.new;
        this.totalProcessedAlarmCount.new = res.data.processedAlarmCount;

        this.totalUntreatedAlarmCount.old = this.totalUntreatedAlarmCount.new;
        this.totalUntreatedAlarmCount.new = res.data.untreatedAlarmCount;
      });
    },
    // 今日的告警数据
    getTodayALarmData() {
      axios({
        url: this.$root.BASE_URL + "/work/alarm_handle/today",
        method: "get",
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        res = res.data;
        this.todayTotalAlarmCount.old = this.todayTotalAlarmCount.new;
        this.todayTotalAlarmCount.new = res.data.totalAlarmCount;

        this.todayProcessedAlarmCount.old = this.todayProcessedAlarmCount.new;
        this.todayProcessedAlarmCount.new = res.data.processedAlarmCount;

        this.todayUntreatedAlarmCount.old = this.todayUntreatedAlarmCount.new;
        this.todayUntreatedAlarmCount.new = res.data.untreatedAlarmCount;
      });
    },
    // 获取每种告警类型的个数
    getAlarmTypeAndCount(queryTime) {
      axios({
        url: this.$root.BASE_URL + "/work/alarm_table/type",
        method: "get",
        params: queryTime,
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        res = res.data;
        this.alarmTypeAndCount.alarmTypeData = res.data.alarmTitle;
        this.alarmTypeAndCount.alarmCountData = res.data.alarmCount;
        // TODO 先人请求完成然后再渲染数据
        this.createPieChart(res.data.alarmTitle, res.data.alarmCount);
      });
    },

    // 底部表格
    shipNavigateStateList() {
      axios({
        url:
          this.$root.BASE_URL + "/work/ship_info/bigView/shipNavigateStateList",
        method: "get",
        params: this.queryParams,
        headers: {
          authorization: this.token,
        },
      }).then((res) => {
        this.navigateStateList = res.data.rows;
        this.total = res.data.total;
        console.log(res, "--------------");
      });
    },

    // 时间范围修改了重新发送请求
    againRequest() {
      if (this.time === null) {
        this.queryTime.startTime = null;
        this.queryTime.endTime = null;
      } else {
        this.queryTime.startTime = this.time[0];
        this.queryTime.endTime = this.time[1];
      }
      // 获取告警类型每种个数
      this.getAlarmTypeAndCount(this.queryTime);

      this.timer = setTimeout(() => {
        this.getAlarmTypeAndCount(this.queryTime);
      }, 500);
    },

    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    getDateRandom() {
      setTimeout(() => {
        var randomValue = Math.floor(Math.random() * 100) + 1; // 生成 1~100 的随机整数
        this.config.number = randomValue;
      }, 10000);
    },
    playNone(){
      this.$refs.live.oWebControl.JS_HideWnd()
      this.show=true

    },
    isPlayBlack(){
      this.$refs.live.oWebControl.JS_HideWnd()
      this.isPaly = false
    }
  },
  computed: {
    defaultOption() {
      return {
        step: 0.8, // 数值越大速度滚动越快
        limitMoveNum: this.currentDataList?.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

#box {
  width: 100vw;
  height: 100vh;
  background-color: #03050c;
  overflow: hidden;
}

.btnTitle {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
  margin-left: 20px;
  padding-top: 20px;
}

.btnStyle {
  background-color: transparent;
  background: #fff;
  border: none;
  padding: 5px;
  border-radius: 5px;
  color: #000;
  margin-right: 10px;
}

.btnActive {
  background: #409eff;
  border-radius: 5px;
  color: #fff;
  padding: 5px;
  margin-right: 10px;
}

/* 改变整个输入框的字体颜色背景 */

.hright .el-input__inner {
  border: 1 solid rgb(0, 223, 255);
  background: rgb(1, 2, 7) !important;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgb(0, 223, 255);
}

/* 改变 两个时间的    字体颜色背景 */

.hright .el-input__inner .el-range-input {
  background: rgb(1, 2, 7) !important;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgb(0, 223, 255) !important;
}

/* 改变 至 的    字体颜色背景 */
.hright .el-input__inner .el-range-separator {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgb(0, 223, 255) !important;
}

.page_left {
  background-color: rgba(0, 0, 0, 0);
  margin: 1%;
  width: 98%;
}

.tree-title {
  color: white;
  margin-top: 4px;
  background: linear-gradient(to right, #424fa8, #43c7dc);
  font-size: 12px;
  height: 30px;

  display: flex;
  //justify-content: center;
  align-items: center;
}

.filter-tree {
  margin-top: 5px;
  height: 279px;
  background-color: #03050c !important;
  color: #fff !important;
  overflow-y: auto;
  font-size: 13px;
  border: 1px solid #22b5ca;
}

.filter-tree::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
}

.bottom_info {
  padding: 0 10px;
  // width: 96%;
  // height: 27%;
  // background: #fff;
  // margin: auto;
}

.videoBtn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
}

.top1 {
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: right;
}

.top2 {
  margin-bottom: 30px;
  margin-top: 10px;
  text-align: center;
}

.page_box {
  padding: 32px;
  background-color: #f0f2f5;
}

.page_top {
  background-color: white;
  padding: 20px;
  width: 100%;
  flex: 2;
}

.page_bottom {
  margin-top: 10px;
  flex: 3;
  display: flex;
}

.page_bottom_left {
  padding: 10px;
  background-color: white;
  flex: 1;
  width: 50%;
}

.page_bottom_right {
  margin-left: 10px;
  padding: 10px;
  background-color: white;
  width: 50%;
  flex: 1;
}

@import "@/assets/css/styles/index.scss";
@import "@/assets/css/index.scss";
@import "@/assets/css/big_view_left.scss";
@import "@/assets/css/big_view_middle.scss";
@import "@/assets/css/big_view_right.scss";

// .scale-wrap .big_view_content .content_left_box .middle_box {
//   height: 27%;
// }
::v-deep .scale-wrap .big_view_content .content_middle_box {
  width: 40vw !important;
}

.record-list-box-box {
  width: 100%;
  float: left;
}

.record-list-box {
  overflow: auto;
  // width: 220px;
  height: 330px;
  color: #fff !important;
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 0px;
  padding: 1rem 0;
  background-color: #03050c !important;
  margin-top: 10px;
}

.record-list-box .el-input__inner {
  color: #fff !important;
}

.record-list {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #03050c !important;
}

.record-list-box::-webkit-scrollbar {
  display: none;
  /* 隐藏滚动条 */
}

.record-list-no-val {
  position: absolute;
  color: #9f9f9f;
  top: 50%;
  left: 110px;
}

.record-list-item {
  padding: 0;
  cursor: pointer;
  background-color: #03050c;
}

.record-list-option {
  width: 10px;
  float: left;
  margin-top: 39px;
}

.player-option-box {
  padding: 0 20px;
}

.player-tools {
  height: 20px;
  width: 20px;
}

.record-list-item {
  margin-left: 40px;
  margin-top: 5px;
}

.record-list-item:first-child {
  margin-top: -1px;
}

ul li {
  list-style: none;
}

li {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

* {
  padding: 0;
  margin: 0;
}

.record-list-box:nth-child(2) {
  margin-left: 20px;
}

.el-tree-node:focus>.el-tree-node__content {
  background-color: #409eff !important;
}

// ::v-deep .el-input__inner {
//   border-image: linear-gradient(to right, #011e75, #23b7cb) 5 5 !important;
//   background-color: #03050c !important;
//   color: #fff !important;
// }
::v-deep .hright .el-input__inner .el-range-input {
  background: #051427 !important;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #c0c4cc;
}

/* 改变 至 的    字体颜色背景 */
::v-deep .hright .el-input__inner .el-range-separator {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #c0c4cc;
}

.playBox {
  // background-color: lightpink;
  width: 100%;
  height: 96%;
  // position: relative;
  // height: 84%;
}

.el-date-editor .el-range-input {
  background-color: #03050c;
  color: #fff !important;
  border-image: linear-gradient(to right, #011e75, #23b7cb) 5 5 !important;
}

.el-date-editor .el-range-separator {
  color: #fff !important;
}

.filter-input-container .el-input--prefix .el-input__inner,
.filter-input .el-input--prefix .el-input__inner {
  color: #fff !important;
}

.el-dropdown {
  padding-top: 3px;
}

.el-button--mini {
  padding: 2px 5px !important;
}

.stateBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // width: 200px;
  // height: 100px;
  // border: 1px solid greenyellow;
}

.tableBox {
  border-image-repeat: stretch;
  border-image-slice: 170;
  border-image-width: 20px;
  border-image-source: url("~@/assets/images/div_border_img_1.png");
  height: 27%;
  margin-top: -6px;
  overflow: hidden;
}
</style>
<style>
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #409eff !important;
}

.el-tree-node__content:hover {
  background-color: #409eff !important;
}

.el-table {
  background-color: transparent !important;
  color: #fff !important;
  border-bottom: none !important;
  border-right: none !important;
  width: 99% !important;
}

.el-table thead {
  color: #fff !important;
}

.el-table th {
  border: none !important;
  border-right: none !important;
}

.el-table td {
  border: none !important;
  border-right: none !important;
}

.el-table tr {
  background-color: transparent !important;
}

.el-table__body td,
.el-table__header th,
.el-table .cell {
  background-color: transparent !important;
}

.el-table::before {
  height: 0px !important;
}

.el-table::after {
  height: 0px !important;
}

.el-table .cell.el-tooltip {
  color: #cf8c3a;
}

.el-table--border {
  border: 1px solid #22b5ca !important;
}

/* .el-table--scrollable-x .el-table__body-wrapper {
  margin-top: 125px;
} */
*::-webkit-scrollbar {
  width: 1px;
  height: 8px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
*::-webkit-scrollbar-track {
  background-color: rgba(117, 116, 116, 0.3);
}

/*定义滚动条轨道 内阴影+圆角*/
*::-webkit-scrollbar-thumb {
  background-color: #43b1d3;
  border-radius: 6px;
}

/*定义滑块 内阴影+圆角*/
.scrollbarHide::-webkit-scrollbar {
  display: none;
}

.alarmRes .el-input__inner {
  box-shadow: none;
}

.one_box_live {
  width: 100%;
  height: 96%;
  /* background-color: lightcoral; */
}
</style>
